// Field labels for the existing master-data and price import workflow.
export const selfImportFieldsDe = {
  tradingName: 'Geschäftsname',
  type: 'Art',
  status: 'Status',
  isCustomer: 'Kundenrolle',
  isSupplier: 'Lieferantenrolle',
  isProspect: 'Interessentenrolle',
  mobile: 'Mobiltelefon',
  website: 'Website',
  documentLanguage: 'Belegsprache',
  paymentTermsDays: 'Zahlungsziel in Tagen',
  cashDiscountDays: 'Skontofrist in Tagen',
  cashDiscountPct: 'Skonto in Prozent',
  defaultDiscountPct: 'Standardrabatt in Prozent',
  creditLimit: 'Kreditlimit',
  deliveryTerms: 'Lieferbedingungen',
  dunningBlock: 'Mahnsperre',
  taxCategory: 'Steuerkategorie',
  department: 'Abteilung',
  language: 'Sprache',
  salutation: 'Anrede',
  title: 'Titel',
  recipient: 'Empfänger',
  addressLine2: 'Adresszusatz',
  purposes: 'Adressverwendung (JSON-Liste)',
  defaultFor: 'Standardadresse für (JSON-Liste)',
  isDefault: 'Standardadresse',
  manufacturerNumber: 'Herstellernummer',
  taxRatePct: 'Steuersatz in Prozent',
  recordExternalId: 'Externe ID des Zielobjekts',
  productExternalId: 'Externe Artikel-ID',
  unitCode: 'Preiseinheit',
  priceAmountBasis: 'Preisart (NET)',
  priceUnitQuantity: 'Preisnenner (1)',
  amountRole: 'Mengenbedeutung (MIN_QUANTITY)',
  validFrom: 'Gültig ab',
  validTo: 'Gültig bis',
  sourcePriceList: 'Ursprüngliche Preisliste',
} as const;

export const selfImportFieldsEn = {
  tradingName: 'Trading name',
  type: 'Type',
  status: 'Status',
  isCustomer: 'Customer role',
  isSupplier: 'Supplier role',
  isProspect: 'Prospect role',
  mobile: 'Mobile phone',
  website: 'Website',
  documentLanguage: 'Document language',
  paymentTermsDays: 'Payment term in days',
  cashDiscountDays: 'Cash discount days',
  cashDiscountPct: 'Cash discount percent',
  defaultDiscountPct: 'Default discount percent',
  creditLimit: 'Credit limit',
  deliveryTerms: 'Delivery terms',
  dunningBlock: 'Dunning block',
  taxCategory: 'Tax category',
  department: 'Department',
  language: 'Language',
  salutation: 'Salutation',
  title: 'Title',
  recipient: 'Recipient',
  addressLine2: 'Address line 2',
  purposes: 'Address purposes (JSON list)',
  defaultFor: 'Default address for (JSON list)',
  isDefault: 'Default address',
  manufacturerNumber: 'Manufacturer number',
  taxRatePct: 'Tax rate percent',
  recordExternalId: 'Target record external ID',
  productExternalId: 'Product external ID',
  unitCode: 'Price unit',
  priceAmountBasis: 'Price basis (NET)',
  priceUnitQuantity: 'Price denominator (1)',
  amountRole: 'Quantity meaning (MIN_QUANTITY)',
  validFrom: 'Valid from',
  validTo: 'Valid until',
  sourcePriceList: 'Original price list',
} as const;

export const selfImportFieldsFr = {
  tradingName: 'Nom commercial',
  type: 'Type',
  status: 'Statut',
  isCustomer: 'Rôle client',
  isSupplier: 'Rôle fournisseur',
  isProspect: 'Rôle prospect',
  mobile: 'Téléphone portable',
  website: 'Site web',
  documentLanguage: 'Langue des documents',
  paymentTermsDays: 'Délai de paiement en jours',
  cashDiscountDays: 'Délai d’escompte en jours',
  cashDiscountPct: 'Escompte en pourcentage',
  defaultDiscountPct: 'Remise par défaut en pourcentage',
  creditLimit: 'Limite de crédit',
  deliveryTerms: 'Conditions de livraison',
  dunningBlock: 'Blocage des relances',
  taxCategory: 'Catégorie fiscale',
  department: 'Service',
  language: 'Langue',
  salutation: 'Civilité',
  title: 'Titre',
  recipient: 'Destinataire',
  addressLine2: 'Complément d’adresse',
  purposes: 'Usages de l’adresse (liste JSON)',
  defaultFor: 'Adresse par défaut pour (liste JSON)',
  isDefault: 'Adresse par défaut',
  manufacturerNumber: 'Référence fabricant',
  taxRatePct: 'Taux de taxe en pourcentage',
  recordExternalId: 'Identifiant externe de l’objet cible',
  productExternalId: 'Identifiant externe de l’article',
  unitCode: 'Unité de prix',
  priceAmountBasis: 'Base du prix (NET)',
  priceUnitQuantity: 'Quantité de référence du prix (1)',
  amountRole: 'Sens de la quantité (MIN_QUANTITY)',
  validFrom: 'Valable à partir du',
  validTo: 'Valable jusqu’au',
  sourcePriceList: 'Liste de prix d’origine',
} as const;

export const selfImportFieldsEs = {
  tradingName: 'Nombre comercial',
  type: 'Tipo',
  status: 'Estado',
  isCustomer: 'Rol de cliente',
  isSupplier: 'Rol de proveedor',
  isProspect: 'Rol de prospecto',
  mobile: 'Teléfono móvil',
  website: 'Sitio web',
  documentLanguage: 'Idioma de documentos',
  paymentTermsDays: 'Plazo de pago en días',
  cashDiscountDays: 'Días de pronto pago',
  cashDiscountPct: 'Descuento por pronto pago',
  defaultDiscountPct: 'Descuento predeterminado (%)',
  creditLimit: 'Límite de crédito',
  deliveryTerms: 'Condiciones de entrega',
  dunningBlock: 'Bloqueo de reclamaciones',
  taxCategory: 'Categoría fiscal',
  department: 'Departamento',
  language: 'Idioma',
  salutation: 'Tratamiento',
  title: 'Título',
  recipient: 'Destinatario',
  addressLine2: 'Complemento de dirección',
  purposes: 'Usos de dirección (lista JSON)',
  defaultFor: 'Dirección predeterminada para (lista JSON)',
  isDefault: 'Dirección predeterminada',
  manufacturerNumber: 'Referencia del fabricante',
  taxRatePct: 'Tipo impositivo (%)',
  recordExternalId: 'ID externo del registro de destino',
  productExternalId: 'ID externo del artículo',
  unitCode: 'Unidad de precio',
  priceAmountBasis: 'Base del precio (NET)',
  priceUnitQuantity: 'Cantidad de referencia del precio (1)',
  amountRole: 'Significado de cantidad (MIN_QUANTITY)',
  validFrom: 'Válido desde',
  validTo: 'Válido hasta',
  sourcePriceList: 'Lista de precios original',
} as const;

export const selfImportFieldsTr = {
  tradingName: 'Ticari ad',
  type: 'Tür',
  status: 'Durum',
  isCustomer: 'Müşteri rolü',
  isSupplier: 'Tedarikçi rolü',
  isProspect: 'Aday müşteri rolü',
  mobile: 'Cep telefonu',
  website: 'Web sitesi',
  documentLanguage: 'Belge dili',
  paymentTermsDays: 'Ödeme vadesi (gün)',
  cashDiscountDays: 'Erken ödeme süresi (gün)',
  cashDiscountPct: 'Erken ödeme indirimi (%)',
  defaultDiscountPct: 'Varsayılan indirim (%)',
  creditLimit: 'Kredi limiti',
  deliveryTerms: 'Teslimat koşulları',
  dunningBlock: 'Ödeme hatırlatma engeli',
  taxCategory: 'Vergi kategorisi',
  department: 'Bölüm',
  language: 'Dil',
  salutation: 'Hitap',
  title: 'Unvan',
  recipient: 'Alıcı',
  addressLine2: 'Adres ek satırı',
  purposes: 'Adres kullanım amaçları (JSON listesi)',
  defaultFor: 'Varsayılan adres amaçları (JSON listesi)',
  isDefault: 'Varsayılan adres',
  manufacturerNumber: 'Üretici numarası',
  taxRatePct: 'Vergi oranı (%)',
  recordExternalId: 'Hedef kaydın harici kimliği',
  productExternalId: 'Ürün harici kimliği',
  unitCode: 'Fiyat birimi',
  priceAmountBasis: 'Fiyat esası (NET)',
  priceUnitQuantity: 'Fiyat paydası (1)',
  amountRole: 'Miktar anlamı (MIN_QUANTITY)',
  validFrom: 'Geçerlilik başlangıcı',
  validTo: 'Geçerlilik sonu',
  sourcePriceList: 'Özgün fiyat listesi',
} as const;

export const selfImportFieldsRu = {
  tradingName: 'Торговое название',
  type: 'Тип',
  status: 'Статус',
  isCustomer: 'Роль клиента',
  isSupplier: 'Роль поставщика',
  isProspect: 'Роль потенциального клиента',
  mobile: 'Мобильный телефон',
  website: 'Веб-сайт',
  documentLanguage: 'Язык документов',
  paymentTermsDays: 'Срок оплаты в днях',
  cashDiscountDays: 'Срок скидки в днях',
  cashDiscountPct: 'Скидка за оплату (%)',
  defaultDiscountPct: 'Стандартная скидка (%)',
  creditLimit: 'Кредитный лимит',
  deliveryTerms: 'Условия доставки',
  dunningBlock: 'Запрет напоминаний',
  taxCategory: 'Налоговая категория',
  department: 'Отдел',
  language: 'Язык',
  salutation: 'Обращение',
  title: 'Титул',
  recipient: 'Получатель',
  addressLine2: 'Дополнение к адресу',
  purposes: 'Назначение адреса (список JSON)',
  defaultFor: 'Адрес по умолчанию для (список JSON)',
  isDefault: 'Адрес по умолчанию',
  manufacturerNumber: 'Номер производителя',
  taxRatePct: 'Налоговая ставка (%)',
  recordExternalId: 'Внешний ID целевого объекта',
  productExternalId: 'Внешний ID товара',
  unitCode: 'Единица цены',
  priceAmountBasis: 'Основа цены (NET)',
  priceUnitQuantity: 'Знаменатель цены (1)',
  amountRole: 'Смысл количества (MIN_QUANTITY)',
  validFrom: 'Действует с',
  validTo: 'Действует до',
  sourcePriceList: 'Исходный прайс-лист',
} as const;
